import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import Container from "../../common/Container";
import Breadcrumbs from "../../common/BreadcrumbsModule";
import Views from "./Views";
import Bar from "./Bar";
import Navigation from "./Navigation";
import OneClickContainer from "./OneClickContainer";
import Advantages from "../../common/Advantages";
import Description from "../../common/Description";
import BeforeFooterText from "./BeforeFooterText";
import Tags from "./Tags";
import Author from "./Author";
import SimilarProducts from "./SimilarProducts";
import SiblingProducts from "./SiblingProducts";
import SocialLinks from "../../common/SocialLinks";
import CartInfo from "./CartInfo";
import BannedInfo from "./BannedInfo";
import Neighboring from "./Neighboring";
import {breadcrumbsSelector} from "../ducks/breadcrumbs";
import {productSelector} from "../ducks/product";
import {seoSelector} from "../ducks/seo";
import {locationDataSelector} from "../ducks/location-data";
import {reviewsSelector} from "../ducks/reviews";
import {urlSelector} from "../ducks/url";
import descriptions from "../../../mocks/product-descriptions";
import {cartInfoSelector} from "../ducks/cart-info";
import {licenseeStoreSelector} from "../ducks/licensee-store";

import styles from "./root.module.scss";

function Root(props) {
  const {
    url,
    breadcrumbs,
    product,
    product: {
      singular,
      permalink,
      name,
      condition,
      title: itemTitle,
      description: itemDescription,
      views,
      banned,
      clones,
      neighboring
    },
    seo,
    locationData,
    reviews,
    cartInfo,
    licenseeStore
  } = props;
  const description = descriptions[singular];
  return (
    <Grid
      container
      className={classNames(styles.root, banned ? styles.banned : ``)}
      itemScope
      itemType="http://schema.org/Product"
    >
      <Grid item xs={12} className={styles.header}>
        <Container>
          <Grid container>
            <Grid item md={7} xs={12} className={styles.breadcrumbs}>
              <Breadcrumbs items={breadcrumbs} />
            </Grid>
            <Grid item md={5} xs={12} className={styles.search}></Grid>
          </Grid>
        </Container>
      </Grid>
      {cartInfo.path && (
        <Grid item xs={12} className={styles.flash}>
          <Container>
            <CartInfo />
          </Container>
        </Grid>
      )}
      {banned && (
        <Grid item xs={12} className={styles.flash}>
          <Container>
            <BannedInfo />
          </Container>
        </Grid>
      )}
      <Grid item xs={12} className={styles.content}>
        <Container>
          <Grid container>
            <Grid item xs={12} className={styles.navigation}>
              <Navigation />
            </Grid>
            <Grid item md={7} xs={12} className={styles.views}>
              <Views />
            </Grid>
            <Grid item md={5} xs={12} className={styles.bar}>
              <Bar />
            </Grid>
          </Grid>
        </Container>
      </Grid>
      {!licenseeStore && (
        <>
          <Grid item xs={12} className={styles.advantages}>
            <Container>
              <Advantages productName={singular} condition={condition} />
            </Container>
          </Grid>
          {description && (
            <Grid item xs={12} className={styles.description}>
              <Container>
                <Description
                  product={product}
                  url={url}
                  seo={seo}
                  locationData={locationData}
                  reviews={reviews}
                  permalink={permalink}
                  clones={clones}
                />
              </Container>
            </Grid>
          )}
          <Grid item xs={12} className={styles.author}>
            <Container>
              <Author />
            </Container>
          </Grid>
          <Grid item xs={12} className={styles.tags}>
            <Container>
              <Tags />
            </Container>
          </Grid>
          <Grid item xs={12} className={styles.socialLinks}>
            <Container>
              <SocialLinks
                url={url}
                title={`${name} ${itemTitle}`}
                description={itemDescription}
                media={views.large ? views.large[0] : `/`}
              />
            </Container>
          </Grid>
          <Grid item xs={12}>
            <Container>
              <BeforeFooterText content={seo.beforeFooterText} />
            </Container>
          </Grid>
          <Grid item xs={12}>
            <SiblingProducts />
          </Grid>
          <Grid item xs={12}>
            <SimilarProducts />
          </Grid>
          <Grid item xs={12}>
            <Container>
              <Neighboring items={neighboring} />
            </Container>
          </Grid>
        </>
      )}
      <OneClickContainer />
    </Grid>
  );
}

Root.propTypes = {
  url: PropTypes.string,
  breadcrumbs: PropTypes.array,
  product: PropTypes.object,
  seo: PropTypes.object,
  locationData: PropTypes.object,
  reviews: PropTypes.object,
  cartInfo: PropTypes.object,
  licenseeStore: PropTypes.bool
};

const mapStateToProps = (state) => ({
  url: urlSelector(state),
  breadcrumbs: breadcrumbsSelector(state),
  product: productSelector(state),
  seo: seoSelector(state),
  locationData: locationDataSelector(state),
  reviews: reviewsSelector(state),
  cartInfo: cartInfoSelector(state),
  licenseeStore: licenseeStoreSelector(state)
});

export default connect(mapStateToProps)(Root);
